import { graphql } from '@prophecy/graphql-types/graphql';
export const AllTeamsQuery = graphql(`
  query allTeamsQuery($uid: String!) {
    User(uid: $uid) {
      teams {
        _id
        teamKind
        name
        InfoAspect: aspects(aspect: Info) {
          AspectName
          AspectValue
        }
        members {
          _id
        }
        admins {
          _id
        }
        createdByFullName
        created
        subscriptionPlan
        teamState
      }
    }
  }
`);
